/**
 * Countries where BIGELEMENT INFOTECH provides services
 * Used for SEO and structured data
 * Using ISO 3166-1 alpha-2 country codes and standard country names
 */

export interface CountryInfo {
  name: string;
  code: string;
  displayName?: string; // Optional shorter/common name for display
}

/**
 * Standard country information with ISO codes
 */
export const SERVICE_COUNTRIES: CountryInfo[] = [
  { name: "India", code: "IN" },
  { name: "United States", code: "US", displayName: "USA" },
  { name: "Australia", code: "AU" },
  { name: "New Zealand", code: "NZ" },
  { name: "United Kingdom", code: "GB", displayName: "UK" },
  { name: "Canada", code: "CA" },
  { name: "United Arab Emirates", code: "AE", displayName: "UAE" },
];

/**
 * Get countries list for structured data (array format)
 * Returns standard country names as per ISO 3166-1
 */
export const getServiceCountries = (): string[] => {
  return SERVICE_COUNTRIES.map((country) => country.name);
};

/**
 * Get country codes list (ISO 3166-1 alpha-2)
 */
export const getServiceCountryCodes = (): string[] => {
  return SERVICE_COUNTRIES.map((country) => country.code);
};

/**
 * Get countries list as string for meta descriptions
 * Uses display names where available, otherwise standard names
 */
export const getServiceCountriesString = (): string => {
  return SERVICE_COUNTRIES.map(
    (country) => country.displayName || country.name
  ).join(", ");
};

/**
 * Get country by code
 */
export const getCountryByCode = (code: string): CountryInfo | undefined => {
  return SERVICE_COUNTRIES.find(
    (country) => country.code.toUpperCase() === code.toUpperCase()
  );
};

/**
 * Get country by name (case-insensitive)
 */
export const getCountryByName = (name: string): CountryInfo | undefined => {
  return SERVICE_COUNTRIES.find(
    (country) =>
      country.name.toLowerCase() === name.toLowerCase() ||
      country.displayName?.toLowerCase() === name.toLowerCase()
  );
};
